module.exports = __webpack_public_path__ + "img/item4.05e038cd.png";